import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceRouter, ServiceDefinition } from '@pershing/pershing-core';

@Injectable()
export class ContentManagementService {
    private headers: HttpHeaders;

    constructor(private serviceRouter: ServiceRouter, private http: HttpClient) {
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }

    retrieveContent(serviceDefinition: ServiceDefinition, requestBody: any): Observable<any> {
        const baseUrl = this.serviceRouter.getServiceRouteURL(serviceDefinition);
        return this.http.post(`${baseUrl}`, requestBody, { headers: this.headers });
    }
}
